module.exports = __webpack_public_path__ + "static/PrimitiveEleven-5358e1cf98cf95029f61c62aa61015c7.png";